<template>
  <JsonEditor
    v-model:value="value"
    @change="handleChangeValue"
  />
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import JsonEditor from 'vue3-ts-jsoneditor';
import { debounce } from 'lodash-es';

export default defineComponent({
  name: 'JsonObj',
  props: {
    value: {
      type: Object,
      required: false,
      default: () => null,
    },
  },
  emits: ['update:value'],
  setup(props, { emit }) {
    const modelValue = ref('');
    if (props.value) {
      try {
        modelValue.value = JSON.stringify(modelValue);
      } catch (e) {
        modelValue.value = null;
      }
    }
    const handleChangeValue = debounce(value => {
      try {
        console.log(value);
        if (value.json) {
          emit('update:value', value.json);
        } else if (value.text) {
          const new_value = JSON.parse(value.text);
          emit('update:value', new_value);
        }
      } catch (e) {
        console.error(e);
      }
    }, 200);
    return {
      props,
      modelValue,
      handleChangeValue,
    };
  },
  components: {
    JsonEditor,
  },
});
</script>
